import React from 'react'
import { Box, Stack, Text } from '@chakra-ui/react'
import { Research, ResearchTag } from '../../../../types/Research'
import ResearchCard from '../../../../components/research/ResearchCard'

interface ResearchListProps {
  filteredResearch: Research[]
  totalResearch: number
  tags: ResearchTag[]
}

const ResearchList: React.FC<ResearchListProps> = ({
  filteredResearch,
  totalResearch,
  tags,
}) => {
  return (
    <Stack spacing={4}>
      {filteredResearch.length === 0 ? (
        <Box textAlign='center' py={8}>
          <Text color='gray.500'>
            {totalResearch === 0
              ? 'No research articles found. Be the first to add one!'
              : 'No research articles match your current filters.'}
          </Text>
        </Box>
      ) : (
        filteredResearch.map((item) => (
          <ResearchCard key={item.id} item={item} tags={tags} />
        ))
      )}
    </Stack>
  )
}

export default ResearchList
